export default __webpack_public_path__ + "static/AC-JPA-aeed2b6e74e226adacd1cd9154d30b40.svg";